import React, { CSSProperties } from "react";
import Button from "components/ui/Button";
import { useFormikContext } from "formik";

export interface PanelButtonsProps {
  submitButtonText?: string;
  noSubmit?: boolean;
  hideActionButton?: boolean;
  close(): void;
  alternateSubmitFunction?: () => void;
  extraStyles?: CSSProperties;
}

// Panel Buttons - Declare as its own component - useFormikContext must be declared in a FC that is rendered inside <Formik>
const PanelButtons: React.FC<PanelButtonsProps> = ({
  submitButtonText = "Submit",
  noSubmit,
  hideActionButton = false,
  close,
  alternateSubmitFunction,
  extraStyles,
}) => {
  const formik = useFormikContext();

  // Custom error to warn user that this must be rendered inside Formik
  if (!formik) {
    throw new Error(`This component must be rendered inside Formik.`);
  }

  return (
    <div className="Buttons" style={extraStyles ?? undefined}>
      <div className="Btn BtnCancel" onClick={close}>
        Cancel
      </div>

      {noSubmit && !hideActionButton && (
        <Button type="button" onClick={close}>
          Close
        </Button>
      )}

      {!noSubmit && !hideActionButton && !alternateSubmitFunction && (
        <Button type="submit" disabled={formik.isSubmitting}>
          {submitButtonText}
        </Button>
      )}

      {!noSubmit && !hideActionButton && alternateSubmitFunction && (
        <Button type="button" onClick={alternateSubmitFunction}>
          {submitButtonText}
        </Button>
      )}
    </div>
  );
};

export { PanelButtons };
